import LivePartner from 'umg-ember-backend/components/record-explorer/for/live-partner';

<template>
  <LivePartner @records={{@model}} @recordType='live-partner' />
</template>
